import {TableSortLabel as MUITableSortLabel} from '@mui/material'

export const TableSortLabel = MUITableSortLabel
